export const getSessionCookie = async (token: string) =>
  await fetch('/api/auth/sign-in', { method: 'GET', cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });

export const resetSessionCookie = async () => await fetch('/api/auth/sign-out', { method: 'GET', cache: 'no-store' });
